import * as React from 'react';
import { FormattedMessage } from "react-intl";
import Tags from '../tags/tags'
import './articleHeroFullLink.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Watch } from 'scrollmonitor-react';

library.add(faArrowRight);

class ArticleHeroFullLink extends React.Component {
  render() {
    let theBlock = this.props.block;
    let inView = this.props.isInViewport;
    let elementHasBeenInView = this.props.isAboveViewport;
 
    // Change classname based on boolean
    let viewClassName = (inView)? 'is-inview-true' : 'is-inview-false';
    let beenViewed = (elementHasBeenInView)? ' is-viewed' : ' is-not-viewed';

    var tmpArticle;    
    var indexOfArticleData = this.props.issueArticles.map(function(o) { return o.articleId; }).indexOf(theBlock.blockLinkedArticle);
    let baseUrl = this.props.baseUrl ? this.props.baseUrl : ".";

    tmpArticle = this.props.issueArticles[indexOfArticleData];

    return (
        <div className={theBlock.blockHideOnMobile ? viewClassName + beenViewed + " d-none d-md-block " + theBlock.blockType : viewClassName + beenViewed + " " + theBlock.blockType}> 
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-md-12 sm-no-pad">
                                <div className="is-image">
                                    <img src={baseUrl+theBlock.blockHeroImage} alt={theBlock.blockHeroImageAlt}/>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-8 col-lg-6 offset-md-1">
                                        <div className="heroIntroBoxOuter">
                                            <div className="heroIntroBox">
                                                <div className="hero-tags"><Tags tags={tmpArticle.articleTags} readTime={tmpArticle.articleReadTime} videoId={tmpArticle.articleVideoId}/></div>
                                                {this.props.pageH1 ? <h1 className="issueTitle">{theBlock.blockTitle}</h1> : <h2 className="issueTitle h1">{theBlock.blockTitle}</h2>}
                                                <div className="issueSummary"><p>{theBlock.blockSummary}</p></div>
                                            </div>
                                            <div className="heroIntroBoxFooter">
                                                <a className='btn btn-primary read-more in-page' onClick={() => {this.props.changeRoute(this.props.issueId, theBlock.blockLinkedArticle)}} href={'./index.html?issueid='+this.props.issueId+'&articleid='+theBlock.blockLinkedArticle+"&lang="+this.props.locale}>
                                                    {theBlock.moreButtonText === "" ? (<FormattedMessage id="General.readMore" defaultMessage="Read More" />) : (<span>{theBlock.moreButtonText}</span>)}
                                                    <span className="more-arrow"><FontAwesomeIcon icon="arrow-right" /></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
  }
}

//const InviewOptions = {offsetY: 0.2, showGuides: false, fullElementInView: false, debounceTime: 30}

export default Watch(ArticleHeroFullLink);
